module.exports = __webpack_public_path__ + "static/media/Incorrect inclination of the tooth11.b344039d.png";